module.exports = __webpack_public_path__ + "static/entry-form-twisted-christmas-16f3648f1c10565c837265aeaffd891c.pdf";